<template>
  <div class="slider-container">
    <button class="btn close-btn" @click="openPhotos">Close</button>
    <div class="slider">
      <transition name="fade" tag="div">
        <figure v-for="i in [currentIndex]" :key="i" class="border-radius">
          <img :src="currentImage.imageUrl || currentImage.image_url" :alt="currentImage.imageDescription || currentImage.description" class="image" />
        </figure>
      </transition>
    </div>
    <div class="img-title" @change="currentImage">{{ currentImage.imageName }}</div>
    <nav v-if="Images && Images.length > 1" class="controls" aria-label="Image Navigation">
      <button
        class="btn arrow"
        @click="
          prev();
          stopSlide();
        "
        href="#"
      >
        <IconBase variant="angle-left" classes="prev" />
      </button>
      <div v-for="(image, index) in Images" :key="index" class="">
        <button
          :class="{ 'indicator-active': index === activeIndex }"
          class="indicator"
          @click="
            indicator(index);
            stopSlide();
          "
          href="#"
          :aria-label="image.imageName"
        ></button>
      </div>
      <button
        class="btn arrow"
        aria-label="Next"
        @click="
          next();
          stopSlide();
        "
        href="#"
      >
        <IconBase variant="angle-right" classes="next" />
      </button>
    </nav>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import IconBase from '../../Common/icons/index.vue';

@Component({
  components: {
    IconBase,
  },
  data() {
    return {
      timer: null,
      currentIndex: 0,
      hideModal: false,
      slide: 0,
      sliding: null,
      sliderActive: false,
    };
  },
  mounted() {
    if (this.Images && this.Images.length > 1) {
      this.startSlide();
    }
  },
  computed: {
    currentImage() {
      return this.Images[Math.abs(this.currentIndex) % this.Images.length];
    },
    activeIndex() {
      return this.currentIndex % this.Images.length;
    },
  },
  methods: {
    startSlide() {
      this.timer = setInterval(this.next, 10000);
    },
    stopSlide() {
      clearInterval(this.timer);
      this.timer = null;
    },
    next() {
      this.currentIndex += 1;
    },
    prev() {
      this.currentIndex -= 1;
    },
    indicator(index) {
      this.currentIndex = index;
    },
  },
})
class PhotoOverlay extends Vue {
  @Prop({ type: Array })
  Images;

  @Prop({ type: Function })
  openPhotos;
}

export default PhotoOverlay;
</script>

<style>
.btn.arrow {
  border: none;
  padding: 0px;
}
.btn.arrow:focus,
.btn.arrow:focus-visible {
  box-shadow: none;
}
.border-radius {
  border-radius: 8px;
  overflow: hidden;
}
.close-btn {
  color: #eaeaea;
  font-size: 19px;
  margin: 0 0 21px 14px;
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 9999;
}
.close-btn:hover {
  color: #4c8ea0;
  text-decoration: none;
}
.controls {
  align-items: center;
  display: inline-block;
  bottom: var(--spacing-xl);
  display: flex;
  position: absolute;
  justify-content: center;
  width: 100%;
}
.fade-enter-active,
.fade-leave-active {
  overflow: hidden;
  visibility: hidden;
  position: absolute;
  width: 100%;
  opacity: 1;
}
.fade-enter {
  visibility: hidden;
  width: 100%;
  opacity: 0;
}
.fade-leave-to {
  visibility: hidden;
  width: 100%;
  opacity: 0;
}
img.image {
  max-width: 90vw;
  max-height: 70vh;
}
.img-title {
  align-items: center;
  bottom: var(--spacing-xxl);
  color: #eaeaea;
  display: flex;
  justify-content: center;
  padding: 10px;
  position: absolute;
  width: 100%;
}
.indicator {
  background-color: #d8d8d8;
  border-radius: 50%;
  border: none;
  display: none;
  float: left;
  height: 15px;
  margin: 0px 3px;
  opacity: 0.6;
  cursor: pointer;
  text-decoration: none;
  width: 15px;
}
.prev,
.next {
  cursor: pointer;
  color: #eaeaea !important;
  font-weight: normal;
  opacity: 0.6;
  text-decoration: none;
}
.prev,
.next {
  text-decoration: none !important;
}
.next {
  float: right;
  margin-left: 10px;
}
.prev {
  float: left;
  margin-right: 10px;
}
.prev:hover,
.prev:focus-visible,
.next:hover,
.next:focus-visible {
  color: #4c8ea0 !important;
  text-decoration: none;
}
.slider-container {
  top: 0px;
  right: 0;
  left: 0;
  bottom: 0px;
  background-color: #252525;
  height: 100%;
  z-index: 99999;
  position: fixed;
  overflow: auto;
}
.slider {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media only screen and (min-device-width: 390px) {
  .controls {
    bottom: var(--spacing-xl);
  }
  .img-title {
    bottom: var(--spacing-xxl);
  }
}
@media only screen and (min-device-width: 614px) {
  .controls {
    bottom: var(--spacing-m);
  }
  .img-title {
    bottom: var(--spacing-xl);
  }
}
@media only screen and (min-device-width: 768px) {
  .indicator {
    display: block;
  }
  .indicator:focus {
    outline: none;
  }
  .indicator-active {
    background-color: #4e97b2;
  }
  .next {
    margin-left: 0px;
  }
  .prev {
    margin-right: 0px;
  }
}
@media only screen and (min-device-width: 820px) {
  .img-title {
    bottom: var(--spacing-xxl);
  }
  .controls {
    bottom: var(--spacing-xl);
  }
}
@media only screen and (min-device-width: 840px) {
  .img-title {
    bottom: var(--spacing-xl);
  }
  .controls {
    bottom: var(--spacing-m);
  }
}
@media only screen and (min-device-width: 912px) {
  .controls {
    bottom: var(--spacing-m);
  }
  .img-title {
    bottom: var(--spacing-xl);
  }
}
@media only screen and (min-width: 1024px) {
  .close-btn {
    top: 8px;
  }
  .controls {
    bottom: var(--spacing-m);
  }
  .img-title {
    bottom: var(--spacing-xl);
  }
  .slider {
    max-height: 93%;
    margin-top: var(--spacing-s);
  }
}
@media only screen and (min-width: 1200px) {
  .controls {
    bottom: var(--spacing-xl);
  }
  .close-btn {
    right: 30px;
    top: 30px;
  }
  .img-title {
    bottom: var(--spacing-xxl);
  }
}
</style>
